module.exports = __webpack_public_path__ + "img/gf.4017b161.svg";